import * as React from 'react';
import PlayerPauseOutlined from './player-pause-outlined';
import PlayerPauseFilled from './player-pause-filled';
import type { IconCombinedProps } from './types';
const PlayerPauseCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <PlayerPauseFilled ref={ref} {...rest} />;
  }
  return <PlayerPauseOutlined ref={ref} {...rest} />;
});
export default PlayerPauseCombined;